import PrizeInfoForm from "./prizeInfoForm.container";

export default PrizeInfoForm;
